// extracted by mini-css-extract-plugin
export default {"HeaderColored":"Content_HeaderColored__O77lD","RoundNumber":"Content_RoundNumber__2lWQY","RoundParagraph":"Content_RoundParagraph__slNNW"};